import { Component, OnInit } from '@angular/core';
import { R3ConversionsComponent } from '../r3-conversions/r3-conversions.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as Highcharts from 'highcharts';
@Component({
	selector: 'app-r1-sem-conversions',
	templateUrl: './r1-sem-conversions.component.html',
	styleUrls: ['./r1-sem-conversions.component.css']
})
export class R1SemConversionsComponent extends R3ConversionsComponent implements OnInit {
	public isR8: boolean;
	public isR103: boolean = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version.toUpperCase() == 'R8' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.directoryName === 'entravision-r103'
				? true
				: false;
		super.ngOnInit();
	}

	processResponseData(responseData: any): void {
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}
		this.metricObject = [
			{
				name: 'conversions',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'conversion rate',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'all conversions',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];

		this.donutPartData = this.conversionsDataProcess(responseData);
		this.generateAxisLabelsSoruce();
		this.widgetsConfiguration.chartConfig.toolTip.formatter = this.getToolTipFormatter();
		this.widgetsConfiguration.chartConfig.dataLabels.formatter = this.getDataLabelFormatter();
		this.widgetsConfiguration.chartConfig.legend.labelFormatter = this.getLegendToolTipFormatter(this.donutPartData);
	}
	getDataLabelFormatter(): any {
		return function (): string {
			return `<div class="sem-labels">${this.key}:${this.percentage.toFixed(2)}%</div>`;
		};
	}
	getLegendToolTipFormatter(data): any {
		if (this.isR103 || this.isR8) {
			return function (): string {
				let text = data[this.index].tooltip
					? `<div class="sem-tooltip">
				<span>${data[this.index].tooltip}</span>
				<span class="sem-arrow"></span>
			</div>`
					: '';
				return (
					`<span aria-label="${data[this.index].tooltip}" class="sem-legend" >
							<span class="sem-legendname">${this.name}: ${this.percentage.toFixed(2)}%</span>` +
					text +
					`</span>`
				);
			};
		} else {
			return function (): string {
				let text = data[this.index].tooltip
					? `<div class="sem-tooltip">
				<span>${data[this.index].tooltip}</span>
				<span class="sem-arrow"></span>
			</div>`
					: '';
				return (
					`<span aria-label="${data[this.index].tooltip}" class="sem-legend" >
							<span class="sem-legendname">${this.name}</span>` +
					text +
					`</span>`
				);
			};
		}
	}
	getToolTipFormatter(): any {
		return function (): string {
			return `<div style='padding: 3px; color: #263238; font-size: 14px;' class="sem-conversion-pie-tooltip">
						<div style='display: flex; align-items: center;'>
							<div class="sem-tooltip-key">${this.key}</div>
						</div>
						<div style='display: flex; align-items: center;'>
							<div class="sem-tooltip-name">Conversions:
								<span class="sem-tooltip-value">${Highcharts.numberFormat(this.y, 0, '', ',')}</span>
							</div>
						</div>	
					</div>`;
		};
	}
}
